import { createTheme as createMuiTheme } from '@mui/material';
import { createPalette } from './create-palette';
import { createComponents } from './create-components';
import { createShadows } from './create-shadows';
import { createTypography } from './create-typography';

// in the file where you are creating the theme (invoking the function `createTheme()`)
import { Theme as MuiTheme } from '@mui/material/styles';

import { Localization } from '@mui/material/locale';

export type Theme = MuiTheme;

export function createTheme(locale: Localization) {
    const palette = createPalette();
    const components = createComponents({ palette });
    const shadows = createShadows();
    const typography = createTypography();

    return createMuiTheme(
        {
            breakpoints: {
                values: {
                    xs: 0,
                    sm: 600,
                    md: 900,
                    lg: 1200,
                    xl: 1440,
                },
            },
            components,
            palette,
            shadows,
            shape: {
                borderRadius: 8,
            },
            typography,

            page: {
                verticalSpacing: 4,
                backgroundColor: '#fafafa',
                template: {
                    base: {
                        paddingX: 5,
                        paddingY: 1,
                    },
                },
            },

            // Old
            spacing: 4,
            searchBar: {
                debounceTime: 200,
                valueLength: 3,
            },

            appBar: {
                height: 48,
            },
            sideBar: {
                width: 256,
                logoContainer: {
                    height: 184,
                },
            },

            button: {
                color: {
                    success: '#28a745',
                },
            },

            table: {
                regular: {
                    defaultRowsPerPage: 15,
                    rowsPerPageOptions: [
                        15,
                        25,
                        35,
                        { label: 'All', value: 999 },
                    ],
                },
                async: {
                    itemsPerRequest: 200,
                    defaultRowsPerPage: 15,
                },
            },

            snackbar: {
                autoHideDuration: 5000,
            },

            layout: {
                textual: {
                    bold: 600,
                },
            },
        },
        locale
    );
}
